


















































































































































































































import skillbar from '@/components/skillbar.vue';
import SelectSearch from '@/components/select-search.vue';
import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import store from '@/store';
// import { bus } from '@/main';
import Vue from 'vue';
import validation from '@/data/validation.vue';
// import router from '@/router';

const bus = new Vue();

const defaultObjInit = () => ({
  skillId: '',
  name: '',
  aka: '',
  description: '',
  parentid: 0,
  skillmasterid: '',
  ratingDescription: 0,
  addToMyPlan: false,
  MyPlan_Relevant: false,
});

export default defineComponent({
  name: 'Professional',
  components: {
    skillbar,
    SelectSearch,
    validation,
  },
  setup() {
    const selectedProfessions = ref([{ ...defaultObjInit() }]);
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const renderReady = ref(false);
    const apiError = ref(false);
    const loading = ref(false);
    const toggleAccordianVal = ref(1);
    const fetchInitialData = () => {
      store.dispatch('professional/getProfessional');
      store.dispatch('profile/getEmployeeProfile');
      store.dispatch('profile/getSkillsProficiency');

      renderReady.value = true;
    };
    onMounted(() => {
      fetchInitialData();
    });
    const skillsProfessions = computed(() => store.getters['professional/skillsProfessions']);
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsLevels = computed(() => store.getters['profile/skillsLevels']);
    const proceedButtonState = computed(() => {
      /* eslint operator-linebreak: ["error", "after"] */
      const arr = JSON.parse(JSON.stringify(selectedProfessions.value));
      // arr = arr.filter((x) => x.ID || x.Title);
      return (
        arr.find((x: { skillId: string }) => x.skillId === '') ||
        arr.find(
          (x: { name: string; skillId: any; ratingDescription: any }) => !(x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') && (!x.skillId || !x.ratingDescription),
        )
      );
    });
    const proceedToNextPage = () => {
      bus.$emit('proceedToNextPage');
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        console.log('proceedToNextTab', path);
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        console.log('isChangeRolePath', path);
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const openSkillDefinition = (index: any) => {
      bus.$emit('openSkillDefinition', index);
    };
    const showExtraOptionsModal = (index: any) => {
      bus.$emit('showExtraOptionsModal', index);
    };
    const toggleAccordian = () => {
      toggleAccordianVal.value = 0;
    };
    const toggleAccordianaddvalue = (i: any) => {
      toggleAccordianVal.value = i + 1;
    };
    const showInformationModal = (id: any, options: any) => {
      console.log(id, options);
      // this.infoModalData = { ...options };
      // this.$refs['extra-options-modal-comp'].$data.isOpen = false;
      // this.$refs['proficiency-modal-comp'].$data.isOpen = false;
      // this.$refs['information-modal-comp'].$data.isOpen = true;
      // this.$refs['lang-proficiency-modal-comp'].$data.isOpen = false;
    };
    const inputValueChanged = (val: any, elem: any) => {
      // console.log('val====================', val);
      // console.log('elem-----------------------', elem);
      // const { key } = elem.dataset;
      // const { id } = elem || {};
      const id = elem || {};
      if (id && id.includes('profession-select-')) {
        const index = parseInt(id.split('profession-select-')[1], 10);
        const obj = skillsProfessions.value.find((x: any) => x.skillId === val.value);
        selectedProfessions.value[index].skillId = obj.skillId;
        selectedProfessions.value[index].name = obj.name;
        selectedProfessions.value[index].ratingDescription = obj.ratingDescription || 0;
        selectedProfessions.value[index].addToMyPlan = obj.addToMyPlan;
        selectedProfessions.value[index].MyPlan_Relevant = false;
        selectedProfessions.value[index].description = obj.Description || '';
        // selectedProfessions.value[index].ProficiencyLevels = obj.ProficiencyLevels || '';
        // selectedProfessions.value[index].Link = obj.Link || null;
        // selectedProfessions.value[index].IdealLevel = obj.IdealLevel || 0;
      }
    };
    const radioBtnClicked = (event: any) => {
      const { target } = event;
      const { id, dataset } = target;
      const { index } = dataset;
      // if ((isIE || isEdge) && !isMobileOnly) return;
      if (id && id.includes('profession-radio-') && selectedProfessions.value[index].ratingDescription) {
        // selectedProfessions.value[index].Level = 0;
      }
    };
    return {
      skillsProfessions,
      skillsLevels,
      isChangeRole,
      renderReady,
      apiError,
      loading,
      toggleAccordianVal,
      skillsEmployeeProfile,
      inputValueChanged,
      radioBtnClicked,
      showInformationModal,
      toggleAccordianaddvalue,
      toggleAccordian,
      selectedProfessions,
      bus,
      proceedToNextPage,
      openSkillDefinition,
      showExtraOptionsModal,
      proceedButtonState,
      proceedToNextTab,
    };
  },
});
